import { TOAST_Z_INDEX } from "@/contexts/ModalContext";
import { Bounce, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Toast() {
  return (
    <ToastContainer
      className="px-3 pt-3"
      style={{ zIndex: TOAST_Z_INDEX }}
      position="top-center"
      autoClose={4000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnFocusLoss
      draggable
      limit={3}
      theme="light"
      transition={Bounce}
    />
  );
}
